export var defaultState = {
    productItems: {
        status: 'unloaded',
        items: [],
    },
    photos: {
        uploadStatus: 'none',
        status: 'unloaded',
        items: [],
    },
    photoUpload: {
        status: 'none',
        uploadProgress: {
            total: 0,
            loaded: 0,
        },
    },
    selectedProductItem: null,
    selectedPhoto: null,
};
